/* ============================================================
   NINAKO — Product page interactions
   Gallery thumbnail swap · variant selection · quantity ·
   sticky variant sync · AJAX add to cart + cart drawer
   ============================================================ */

(function () {
  if (window.customElements.get('nk-product-page')) return;

  class NkProductPage extends HTMLElement {
    connectedCallback() {
      this.idInput = this.querySelector('[data-nk-variant-id]');
      this.priceEls = this.querySelectorAll('[data-nk-price]');
      this.sizeLabelEls = this.querySelectorAll('[data-nk-size-label]');
      this.qtyInput = this.querySelector('[data-nk-qty-input]');
      this.mainImg = this.querySelector('[data-nk-main-img]');
      this.atc = this.querySelector('[data-nk-atc]');
      this.brenndauerEls = this.querySelectorAll('[data-nk-brenndauer]');
      this.grammzahlEls = this.querySelectorAll('[data-nk-grammzahl]');
      this.stickyVariantBtns = this.querySelectorAll('[data-nk-sticky-variant]');
      this.stickySelect = this.querySelector('[data-nk-sticky-select]');

      this._bindGallery();
      this._bindVariants();
      this._bindQuantity();
      this._bindStickyVariants();
      this._bindStickySelect();
    }

    /* ---- gallery ---- */
    _bindGallery() {
      this.querySelectorAll('[data-nk-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const src = btn.getAttribute('data-src');

          if (this.mainImg && src) {
            this.mainImg.style.backgroundImage = 'url(' + src + ')';
          }

          this.querySelectorAll('[data-nk-thumb]').forEach((b) => {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    }

    /* ---- variants ---- */
    _bindVariants() {
      this.querySelectorAll('[data-nk-variant]').forEach((input) => {
        input.addEventListener('change', () => {
          this._selectVariant(input);
        });
      });
    }

    _selectVariant(input) {
      if (input.disabled) return;

      const id = input.getAttribute('data-variant-id');
      const price = input.getAttribute('data-price');
      const label = input.getAttribute('data-short') || '';
      const brenndauer = input.getAttribute('data-brenndauer') || '';
      const grammzahl = input.getAttribute('data-grammzahl') || '';
      const available = input.getAttribute('data-available') === 'true';

      if (this.stickySelect) {
        this.stickySelect.value = id;
      }

      if (this.idInput) {
        this.idInput.value = id;
      }

      this.priceEls.forEach((el) => {
        el.textContent = price;
      });

      this.sizeLabelEls.forEach((el) => {
        el.textContent = label;
      });

      this.brenndauerEls.forEach((el) => {
        if (brenndauer) {
          el.textContent = brenndauer;
        }
      });

      this.grammzahlEls.forEach((el) => {
        if (grammzahl) {
          el.textContent = grammzahl + ' Gramm';
        }
      });

      if (this.atc) {
        if (available) {
          this.atc.removeAttribute('disabled');
          this.atc.textContent =
            this.atc.getAttribute('data-label') || 'In den Warenkorb';
        } else {
          this.atc.setAttribute('disabled', 'disabled');
          this.atc.textContent =
            this.atc.getAttribute('data-soldout') || 'Ausverkauft';
        }
      }

      this.querySelectorAll('[data-nk-variant-tile]').forEach((tile) => {
        tile.classList.toggle(
          'is-selected',
          tile.getAttribute('for') === input.id
        );
      });

      this.stickyVariantBtns.forEach((btn) => {
        btn.classList.toggle(
          'is-active',
          btn.getAttribute('data-target-variant') === id
        );
      });
    }

    /* ---- sticky select ---- */
    _bindStickySelect() {
      if (!this.stickySelect) return;

      this.stickySelect.addEventListener('change', () => {
        const variantId = this.stickySelect.value;

        const input = this.querySelector(
          '[data-nk-variant][data-variant-id="' + variantId + '"]'
        );

        if (!input || input.disabled) return;

        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* ---- quantity ---- */
    _bindQuantity() {
      const dec = this.querySelector('[data-nk-qty-dec]');
      const inc = this.querySelector('[data-nk-qty-inc]');

      if (dec) {
        dec.addEventListener('click', () => this._step(-1));
      }

      if (inc) {
        inc.addEventListener('click', () => this._step(1));
      }
    }

    _step(dir) {
      if (!this.qtyInput) return;

      let value = parseInt(this.qtyInput.value, 10) || 1;
      value = Math.max(1, value + dir);
      this.qtyInput.value = value;
    }

    /* ---- sticky variants desktop ---- */
    _bindStickyVariants() {
      this.stickyVariantBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = btn.getAttribute('data-target-variant');

          const input = this.querySelector(
            '[data-nk-variant][data-variant-id="' + variantId + '"]'
          );

          if (!input || input.disabled) return;

          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }

  window.customElements.define('nk-product-page', NkProductPage);
})();


/* ============================================================
   NINAKO — AJAX Add to Cart + Cart Drawer
   ============================================================ */

document.addEventListener('submit', async function (event) {
  const form = event.target.closest('form[action*="/cart/add"]');

  if (!form) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const button = form.querySelector('[data-nk-atc]');
  const cartDrawer = document.querySelector('cart-drawer');

  if (button && button.disabled) return;

  const formData = new FormData(form);

  if (
    cartDrawer &&
    typeof cartDrawer.getSectionsToRender === 'function'
  ) {
    const sections = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);

    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);
  }

  try {
    if (button) {
      button.disabled = true;
    }

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(
        result.description || 'Produkt konnte nicht hinzugefügt werden.'
      );
    }

    if (
      cartDrawer &&
      typeof cartDrawer.renderContents === 'function'
    ) {
      cartDrawer.renderContents(result);
    } else {
      console.error('NINAKO: Cart Drawer nicht gefunden.');
    }
  } catch (error) {
    console.error('NINAKO Add to Cart:', error);
  } finally {
    if (button) {
      button.disabled = false;
    }
  }
}, true);